<template>
    <svg class="icon-check" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" fill="#ED702A"/>
        <path d="M13.0206 23.1225L7.32812 17.43L9.92229 14.8358L13.0206 17.9433L22.0773 8.8775L24.6715 11.4717L13.0206 23.1225Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: "IconCheck"
}
</script>